import {Fancybox} from "@fancyapps/ui";


/**
 * @see https://fancyapps.com/fancybox/getting-started/
 */
const setupPhotoGalleries = () =>
{
	// noinspection JSUnresolvedReference
	Fancybox.bind();
};


/**
 *
 */
export default setupPhotoGalleries;